import { useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Header, Footer, CheckoutBanner } from './components'
import { HomePage, ProductsPage, TryOnPage, ConfiguratorPage } from './pages'
import { useSimpleRouter } from './hooks'
import styles from './App.module.css'

const pageTransition = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
  transition: { duration: 0.3, ease: [0.25, 0.1, 0.25, 1] as const },
}

function App() {
  const { currentRoute } = useSimpleRouter()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior })
  }, [currentRoute])

  const renderPage = () => {
    switch (currentRoute) {
      case 'products':
        return <ProductsPage />
      case 'try-on':
        return <TryOnPage />
      case 'customize':
        return <ConfiguratorPage />
      default:
        return <HomePage />
    }
  }

  return (
    <>
      <a href="#main-content" className="skip-link">
        Saltar al contenido principal
      </a>
      <CheckoutBanner />
      <Header />
      <main id="main-content" className={styles.main}>
        <AnimatePresence mode="wait">
          <motion.div key={currentRoute} {...pageTransition}>
            {renderPage()}
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
    </>
  )
}

export default App
